var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33263 8.33323L2.74346 8.92239L2.1543 8.33323L2.74346 7.74406L3.33263 8.33323ZM17.4993 14.9999C17.4993 15.2209 17.4115 15.4329 17.2552 15.5891C17.0989 15.7454 16.887 15.8332 16.666 15.8332C16.4449 15.8332 16.233 15.7454 16.0767 15.5891C15.9204 15.4329 15.8326 15.2209 15.8326 14.9999H17.4993ZM6.91013 13.0891L2.74346 8.92239L3.9218 7.74406L8.08846 11.9107L6.91013 13.0891ZM2.74346 7.74406L6.91013 3.57739L8.08846 4.75573L3.9218 8.92239L2.74346 7.74406ZM3.33263 7.49989H11.666V9.16656H3.33263V7.49989ZM17.4993 13.3332V14.9999H15.8326V13.3332H17.4993ZM11.666 7.49989C13.2131 7.49989 14.6968 8.11447 15.7908 9.20844C16.8847 10.3024 17.4993 11.7861 17.4993 13.3332H15.8326C15.8326 12.2282 15.3936 11.1683 14.6122 10.3869C13.8308 9.60555 12.771 9.16656 11.666 9.16656V7.49989Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.e8b3a7806bffe0c2012e9cc6fe3feda9.svg";
export { ForwardRef as ReactComponent };